exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.highlighted[data-v-8bcca2c2] {\n  color: #1f78d1;\n  font-weight: 600;\n}\n", ""]);

// exports
